import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || "";
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || "";

export const isConfigured = () =>
  SUPABASE_URL.startsWith("https://") && SUPABASE_ANON_KEY.length > 20;

export const supabase = isConfigured()
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
  : null;

/*
SQL A EXECUTER DANS SUPABASE (SQL Editor -> New Query) :

create table if not exists maisons (
  id bigint primary key,
  user_id uuid references auth.users(id) on delete cascade not null,
  data jsonb not null,
  created_at timestamptz default now(),
  updated_at timestamptz default now()
);

create index if not exists maisons_user_id_idx on maisons(user_id);

create table if not exists budgets (
  user_id uuid primary key references auth.users(id) on delete cascade,
  data jsonb not null,
  updated_at timestamptz default now()
);

alter table maisons enable row level security;
alter table budgets enable row level security;

create policy "Users see own maisons" on maisons
  for all using (auth.uid() = user_id);

create policy "Users see own budget" on budgets
  for all using (auth.uid() = user_id);
*/
